// @ts-strict-ignore
import React from 'react'
import { ImageURISource, View } from 'react-native'
import styled, { useTheme } from 'styled-components/native'
import Typography from 'APP/Converse/Typography'
import Logo from 'APP/Components/Logo'
import Icon from 'APP/Converse/Icon'

const Container = styled.View`
  align-items: start;
  gap: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

const Title = styled.View`
  gap: ${({ theme }) => theme.metrics.baseMargin / 4}px;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin / 2}px;
`

const LogoHeader = ({
  source,
  title,
  subtitle,
  icon,
  testID,
  titleVariant = 'h1',
}: {
  title?: string
  subtitle?: string | React.ReactNode
  source?: ImageURISource
  icon?: { src: string; colour: string; variant: string }
  titleVariant?: 'h1' | 'h2' | 'h3'
  testID?: string
}) => {
  const theme = useTheme()

  return (
    <Container testID={testID}>
      {source && <Logo source={source} />}
      <View>
        <Title>
          <Typography variant={titleVariant}>{title}</Typography>
          {icon && (
            <Icon
              src={icon.src}
              variant={icon.variant}
              size={theme.fonts.fontSize.h2}
              color={icon.colour}
            />
          )}
        </Title>
        {typeof subtitle === 'string' ? <Typography>{subtitle}</Typography> : subtitle}
      </View>
    </Container>
  )
}

export default LogoHeader
